import React, { FC } from 'react';
import { Box, Grid, Paper, TextField, Typography } from '@mui/material';
import { LabClient } from 'models/client-directory';
import { useTranslation } from 'react-i18next';
import AddressForm from 'components/shared/address/address-form.component';

type InfoBySupplierProps = {
    labClient: LabClient;
};

const InfoBySupplier: FC<InfoBySupplierProps> = ({ labClient }: InfoBySupplierProps) => {
    const { t: translate } = useTranslation(['organization', 'common', 'client-directory', 'organization-numbers']);

    return (
        <Paper>
            <Box p={2}>
                <Typography mb={2} variant="h4">
                    {translate('client-directory:CONTACT_INFO_BY_SUPPLIER')}
                </Typography>
                <Grid container spacing={2}>
                    <Grid item sm={4} xs={12}>
                        <TextField
                            label={translate('organization:DENTHUB_CLINIC_NAME')}
                            variant="standard"
                            value={labClient?.lab.name}
                            inputProps={{ readOnly: true }}
                            fullWidth
                        />
                    </Grid>
                    <Grid item sm={4} xs={12}>
                        <TextField
                            label={translate('organization:ORGANIZATION_OFFICIAL_NAME')}
                            variant="standard"
                            value={labClient?.lab.officialName}
                            inputProps={{ readOnly: true }}
                            fullWidth
                        />
                    </Grid>
                    <Grid item sm={4} xs={12}>
                        {/* TODO: Use label based on country*/}
                        <TextField
                            label={translate('organization-numbers:SE_ORGANIZATION_NUMBER')}
                            variant="standard"
                            value={labClient?.lab.organizationNumber}
                            inputProps={{ readOnly: true }}
                            fullWidth
                        />
                    </Grid>

                    <Grid item sm={4} xs={12}>
                        <TextField
                            label={translate('common:PHONE')}
                            variant="standard"
                            value={labClient?.lab.contact?.communication?.phone || ' '}
                            inputProps={{ readOnly: true }}
                            fullWidth
                        />
                    </Grid>
                    <Grid item sm={4} xs={12}>
                        <TextField
                            label={translate('common:EMAIL')}
                            variant="standard"
                            value={labClient?.lab.contact?.communication?.email || ' '}
                            inputProps={{ readOnly: true }}
                            fullWidth
                        />
                    </Grid>
                    <Grid item sm={4} xs={12}>
                        <TextField
                            label={translate('common:WEBSITE')}
                            variant="standard"
                            value={labClient?.lab.contact?.communication?.site || ' '}
                            inputProps={{ readOnly: true }}
                            fullWidth
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <AddressForm address={labClient?.lab.contact.address} disableChageAddress />
                    </Grid>
                </Grid>
            </Box>
        </Paper>
    );
};

export default InfoBySupplier;
